export default __webpack_public_path__ + "static/media/GKxTS.9e57f35d.jpg";